import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/club-logo.png'


const _withScopeId = n => (_pushScopeId("data-v-93c258e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title_box" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "title_right" }

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["title_text_overlay", { hide : _ctx.dToggle }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["title_left", { hide : _ctx.iToggle }])
      }, _hoisted_3, 2),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h1", null, _toDisplayString(_ctx.titleText), 1)
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["title_caption", { hide : _ctx.cToggle }])
    }, " we play jazz music sometimes ", 2)
  ], 2))
}